var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0237 26.9113H14.1001V16.4798C14.1001 16.0342 14.2771 15.6069 14.5922 15.2919C14.9072 14.9768 15.3345 14.7998 15.7801 14.7998H23.9617C24.4073 14.7998 24.8346 14.9768 25.1496 15.2919C25.4647 15.6069 25.6417 16.0342 25.6417 16.4798L25.6417 25.6694V20.2706H29.2201C29.6657 20.2706 30.093 20.4476 30.408 20.7627C30.7231 21.0777 30.9001 21.505 30.9001 21.9506V26.8861H27.6601M23.9113 26.9114H19.4845M17.9558 20.9943L21.7861 20.9942M21.7861 20.9942L19.955 22.9262M21.7861 20.9942L19.955 19.0706M19.4845 27.4694C19.4845 28.4251 18.7099 29.1998 17.7542 29.1998C16.7985 29.1998 16.0237 28.4251 16.0237 27.4694C16.0237 26.5138 16.7985 25.739 17.7542 25.739C18.7099 25.739 19.4845 26.5138 19.4845 27.4694ZM27.7609 27.4694C27.7609 28.4251 26.9861 29.1998 26.0304 29.1998C25.0748 29.1998 24.3001 28.4251 24.3001 27.4694C24.3001 26.5138 25.0748 25.739 26.0304 25.739C26.9861 25.739 27.7609 26.5138 27.7609 27.4694Z",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "ceaa0fb77dc60d85b82dd87b22f14e2a.svg";
export { ForwardRef as ReactComponent };